import React from 'react';
import Carousel from 'react-material-ui-carousel';
import { Paper, Typography, useTheme } from '@mui/material';
import { grey } from '@mui/material/colors';
import styles from './imageCarousel.module.scss';

interface ImageCarouselProps {
  items: { image: string; text: string }[];
}
export function ImageCarousel({ items }: ImageCarouselProps) {
  const theme = useTheme();
  return (
    <Carousel
      swipe
      animation="slide"
      duration={200}
      navButtonsAlwaysVisible
      className={styles.container}
      navButtonsProps={{
        style: {
          backgroundColor: 'transparent',
          color: grey[50],
        },
      }}
      indicatorContainerProps={{
        style: {
          position: 'relative',
        },
      }}
    >
      {items.map((item, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={i}>
          <Paper
            elevation={0}
            sx={{
              justifyContent: 'center',
              display: 'flex',
            }}
            className={styles.container}
          >
            <img src={item.image} alt={item.text} />
          </Paper>
          <div className={styles.imageText}>
            <Typography
              variant="h6"
              fontWeight="bold"
              color={theme.palette.text.primary}
            >
              {item.text}
            </Typography>
          </div>
        </div>
      ))}
    </Carousel>
  );
}
